/* Product Page - Price Calculation & Update */

document.addEventListener("DOMContentLoaded", function () {
  // Prevent execution on cart page
  if (window.location.pathname.startsWith("/cart")) {
    console.log("Skipping script execution on cart page");
    return;
  }

  console.log("DOM fully loaded and parsed");

  // Helper function to parse prices (from attributes or text)
  function parsePrice(priceEl, fallbackText = false) {
    let price = parseFloat(
      priceEl.getAttribute("data-regular-price") ||
        priceEl.getAttribute("data-sale-price") ||
        ""
    );
    if (isNaN(price) && fallbackText) {
      // Parse visible text content as a fallback
      let visiblePrice = priceEl.textContent.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
      price = parseFloat(visiblePrice);
    }
    return price || 0; // Return 0 if the price is still invalid
  }

  // Helper function to format prices with two decimals and commas
  function formatPrice(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(amount);
  }

  // Select all quantity blocks
  var quantityBlocks = document.querySelectorAll(".quantity_block");

  if (quantityBlocks.length) {
    console.log(`Found ${quantityBlocks.length} quantity blocks`);

    quantityBlocks.forEach(function (block) {
      var inputEl = block.querySelector('[name="quantity"]');
      var minusBtn = block.querySelector(".minus_btn");
      var plusBtn = block.querySelector(".plus_btn");

      if (!inputEl || !minusBtn || !plusBtn) {
        console.error(
          "One or more required elements (input, minus, or plus button) are missing in this block."
        );
        return;
      }

      // Remove existing event listeners (if any) to avoid duplication
      minusBtn.replaceWith(minusBtn.cloneNode(true));
      plusBtn.replaceWith(plusBtn.cloneNode(true));
      inputEl.replaceWith(inputEl.cloneNode(true));

      minusBtn = block.querySelector(".minus_btn");
      plusBtn = block.querySelector(".plus_btn");
      inputEl = block.querySelector('[name="quantity"]');

      // Add click event listener to the minus button
      minusBtn.addEventListener("click", function (e) {
        e.preventDefault();

        console.log("Minus button clicked");

        var currentQty = parseInt(inputEl.value) || 1;
        currentQty = Math.max(1, currentQty - 1); // Decrement and ensure the quantity doesn't drop below 1
        inputEl.value = currentQty;

        console.log(`Quantity updated to: ${currentQty}`);
        updatePrices(currentQty);
      });

      // Add click event listener to the plus button
      plusBtn.addEventListener("click", function (e) {
        e.preventDefault();

        console.log("Plus button clicked");

        var currentQty = parseInt(inputEl.value) || 1;
        currentQty += 1; // Increment the quantity
        inputEl.value = currentQty;

        console.log(`Quantity updated to: ${currentQty}`);
        updatePrices(currentQty);
      });

      // Listen for manual input changes
      inputEl.addEventListener("input", function () {
        var currentQty = parseInt(inputEl.value) || 1;
        currentQty = Math.max(1, currentQty); // Prevent quantity from going below 1
        inputEl.value = currentQty;

        console.log(`Quantity manually updated to: ${currentQty}`);
        updatePrices(currentQty);
      });
    });
  } else {
    console.error("No quantity blocks found in the DOM.");
  }

  // Function to update prices based on quantity
  function updatePrices(qty) {
    var regularPriceEl = document.querySelector(".price-item--regular");
    var salePriceEl = document.querySelector(".price-item--sale");

    if (regularPriceEl && salePriceEl) {
      console.log("Price elements found");

      // Parse prices using the helper function
      var baseRegularPrice = parsePrice(regularPriceEl, true); // Already in dollars
      var baseSalePrice = parsePrice(salePriceEl, true); // Already in dollars

      if (isNaN(baseRegularPrice) || isNaN(baseSalePrice)) {
        console.error("Price parsing failed.");
        console.log(
          "Regular Price Element Text Content:",
          regularPriceEl.textContent
        );
        console.log(
          "Sale Price Element Text Content:",
          salePriceEl.textContent
        );
        return;
      }

      console.log(
        `Base regular price: ${baseRegularPrice}, Base sale price: ${baseSalePrice}`
      );

      // Calculate the total price (per-unit price * quantity)
      var newRegularPrice = baseRegularPrice * qty;
      var newSalePrice = baseSalePrice * qty;

      // Format the prices with two decimal places and commas
      regularPriceEl.textContent = formatPrice(newRegularPrice);
      salePriceEl.textContent = formatPrice(newSalePrice);

      console.log(
        `Prices updated: Regular - ${formatPrice(
          newRegularPrice
        )}, Sale - ${formatPrice(newSalePrice)}`
      );
    } else {
      console.error("Price elements not found in the DOM.");
    }
  }
});

/* Cart Drawer */

document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ Cart Drawer Script Loaded");

  function formatPrice(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(amount);
  }

  async function fetchCart() {
    console.log("📡 Fetching updated cart data...");
    try {
      let response = await fetch("/cart.js");
      let cart = await response.json();
      console.log("✅ Cart data fetched:", cart);
      return cart;
    } catch (error) {
      console.error("❌ Error fetching cart data:", error);
    }
  }

  function openCartDrawer() {
    console.log("🛒 Opening Cart Drawer...");
    const cartDrawer = document.querySelector("#sidebar-cart");
    if (cartDrawer) {
      cartDrawer.classList.add("is-open", "show", "not-empty");
      cartDrawer.setAttribute("aria-modal", "true");
      cartDrawer.setAttribute("tabindex", "-1");
      console.log("✅ Cart Drawer Opened");
    }
  }

  function updateCartDrawer(cart) {
    console.log("🔄 Updating Cart Drawer...");
    const cartDrawer = document.querySelector("#sidebar-cart");
    const cartTotalPriceEl = document.querySelector("[data-cart-subtotal]");
    const cartCountEl = document.querySelector(".header_cart_count");
    const cartTotalPriceHeaderEl = document.querySelector(".cart_total_price");
    const emptyCartMessage = cartDrawer.querySelector(".Cart__Empty");
    const emptyCartButtons = cartDrawer.querySelector(".empty_cart_buttons");
    let cartItemsContainer = cartDrawer.querySelector(".Cart__ItemList");
    let drawerFooter = cartDrawer.querySelector(".Drawer__Footer");

    if (!cartDrawer) {
      console.error("❌ Cart Drawer element not found.");
      return;
    }

    // ✅ Update subtotal in cart drawer
    if (cartTotalPriceEl) {
      cartTotalPriceEl.textContent = formatPrice(cart.total_price / 100);
    }

    // ✅ Update total price in the header cart section
    if (cartTotalPriceHeaderEl) {
      cartTotalPriceHeaderEl.textContent = formatPrice(cart.total_price / 100);
    }

    // ✅ Update header cart count
    if (cartCountEl) {
      cartCountEl.textContent = cart.item_count;
    }

    // ✅ Handle Empty Cart State
    if (cart.item_count === 0) {
      emptyCartMessage.style.display = "block";
      emptyCartButtons.style.display = "block";
      if (cartItemsContainer) cartItemsContainer.style.display = "none";
      return;
    } else {
      emptyCartMessage.style.display = "none";
      emptyCartButtons.style.display = "none";
    }

    // 🔹 If `.Cart__ItemList` is missing, create it dynamically
    if (!cartItemsContainer) {
      console.warn("⚠️ Cart items container missing. Creating...");
      cartItemsContainer = document.createElement("div");
      cartItemsContainer.classList.add("Cart__ItemList");

      const drawerMain = cartDrawer.querySelector(".Drawer__Main");
      if (drawerMain) {
        drawerMain.insertBefore(cartItemsContainer, emptyCartMessage);
      }
    }

    // ✅ Update cart items
    cartItemsContainer.innerHTML = "";
    cart.items.forEach((item) => {
      const itemHTML = `
        <div class="CartItemWrapper">
            <div class="CartItem">
                <div class="CartItem__ImageWrapper">
                    <a href="${item.url}">
                        <img src="${item.image}" alt="${
        item.title
      }" loading="lazy">
                    </a>
                </div>
                <div class="CartItem__Info">
                    <h5 class="CartItem__Title">
                        <a href="${item.url}">${item.title}</a>
                    </h5>
                    <div class="CartItem__Meta">
                        <div class="CartItem__Actions">
                            <div class="CartItem__QuantitySelector">
                                <a href="/cart/change?quantity=${
                                  item.quantity - 1
                                }&id=${
        item.key
      }" class="QuantitySelector__Button" data-action="decrease">-</a>
                                <input type="text" value="${
                                  item.quantity
                                }" data-line-id="${item.key}">
                                <a href="/cart/change?quantity=${
                                  item.quantity + 1
                                }&id=${
        item.key
      }" class="QuantitySelector__Button" data-action="increase">+</a>
                            </div>
                            <div class="CartItem__PriceList">
                                <span>${formatPrice(
                                  item.line_price / 100
                                )}</span>
                            </div>
                            <a href="/cart/change?quantity=0&id=${
                              item.key
                            }" class="CartItem__Remove" data-action="remove-item">Remove</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
      cartItemsContainer.insertAdjacentHTML("beforeend", itemHTML);
    });

    // 🔥 Ensure Drawer Footer (Buttons, Shipping Notice, Order Slots) is Updated
    if (!drawerFooter) {
      console.warn("⚠️ Drawer Footer missing, adding it now...");
      drawerFooter = document.createElement("div");
      drawerFooter.classList.add("Drawer__Footer");
      cartDrawer.appendChild(drawerFooter);
    }

    // ✅ Update Buttons & Additional Elements
    drawerFooter.innerHTML = `
      <div class="cart-subtotal h6">
        <span class="cart-subtotal__title">Subtotal</span>
        <span class="cart-subtotal__price" data-cart-subtotal="">
          ${formatPrice(cart.total_price / 100)}
        </span>
      </div>
      
      <div class="cart__block">
        <div class="cart_block__title h6">
          <span>Order notes</span>
        </div>
        <div class="cart_block__content">
          <textarea name="note" id="DrawerCartSpecialInstructions" class="cart-note__input" data-cart-notes="" placeholder="Write your note"></textarea>
        </div>
      </div>

      <button type="submit" name="checkout" class="Cart__Checkout btn btn--primary">
          <span>Checkout</span>
      </button>

      <button type="button" class="Cart__Checkout btn btn--transparent_secondary" data-action="close-drawer" data-drawer-id="sidebar-cart">
          <span>Keep Shopping</span>
      </button>
    `;

    console.log("✅ Cart Drawer Updated.");
  }

  async function handleAddToCartButtonClick() {
    const addToCartBtn = document.querySelector("[data-add-to-cart]");
    if (!addToCartBtn) {
      console.error("❌ Add to Cart button not found.");
      return;
    }

    addToCartBtn.addEventListener("click", async function (e) {
      e.preventDefault();
      console.log("🛒 Add to Cart button clicked");

      const loader = document.querySelector("[data-loader]");
      if (loader) loader.classList.remove("hide");

      let form = addToCartBtn.closest("form");
      if (!form) {
        console.error("❌ Add to Cart form not found.");
        return;
      }

      let formData = new FormData(form);

      try {
        let response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });

        let data = await response.json();
        console.log("✅ Item added:", data);

        let cart = await fetchCart();
        if (cart) {
          updateCartDrawer(cart);
          openCartDrawer();
        }
      } catch (error) {
        console.error("❌ Error adding item to cart:", error);
      } finally {
        if (loader) loader.classList.add("hide");
      }
    });
  }

  function initCartDrawerUpdates() {
    handleAddToCartButtonClick();
  }

  initCartDrawerUpdates();
});
